import { __awaiter, __generator } from "tslib";
import { useMeetingManager } from 'amazon-chime-sdk-component-library-react';
import { useEffect, useState } from 'react';
import { useVideoConfig } from '../video-config-provider';
export var InitMeeting = function (_a) {
    var children = _a.children;
    var meetingManager = useMeetingManager();
    var data = useVideoConfig().data;
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    useEffect(function () {
        initMeeting(data);
        return function () {
            meetingManager.leave();
        };
    }, []);
    var initMeeting = function (_a) {
        var Attendee = _a.Attendee, Meeting = _a.Meeting;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, meetingManager.join({
                            meetingInfo: Meeting,
                            attendeeInfo: Attendee,
                        })];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, meetingManager.start()];
                    case 2:
                        _b.sent();
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    return loading ? null : children;
};
//# sourceMappingURL=init-meeting.js.map